import { INPUT_MASKS, maskInput } from "../../../lib/formatting";
import StyledInput from "./StyledInput";
import {
  StyledInputLabelProps,
  StyledInputProps,
  StyledInputValidationProps,
} from "./StyledInput/StyledInput";

type Props = Omit<StyledInputProps, "value" | "onChange"> & {
  value: string;
  onChange: (v: string) => void;
} & StyledInputLabelProps &
  StyledInputValidationProps;

export default function StyledZipcodeInput({ onChange, ...props }: Props) {
  return (
    <StyledInput
      {...props}
      onChange={(e) => onChange(maskInput(INPUT_MASKS.zipCode, e.target.value))}
    />
  );
}
